module.exports = __webpack_public_path__ + "static/media/Metropolis-Regular.7a63e458.eot";